/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_OlympicInputs */

const en_us2_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

const pt_br2_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

const es_419_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

const pt_pt2_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

const fr_fr2_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

const de_de2_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

const it_it2_workout_logging_bar_olympic = /** @type {(inputs: Workout_Logging_Bar_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 kg`)
};

/**
* | output |
* | --- |
* | "20 kg" |
*
* @param {Workout_Logging_Bar_OlympicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_olympic = /** @type {((inputs?: Workout_Logging_Bar_OlympicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_OlympicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_olympic(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_olympic(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_olympic(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_olympic(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_olympic(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_olympic(inputs)
	return en_us2_workout_logging_bar_olympic(inputs)
});
export { workout_logging_bar_olympic as "workout-logging.bar_olympic" }